var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransportation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69425 0C5.71658 0 4.8822 0.706826 4.72147 1.6712L3.5 9H1C0.447715 9 0 9.44771 0 10C0 11.1046 0.89543 12 2 12H3L1.6 13.8667C0.561423 15.2514 0 16.9357 0 18.6667V24C0 25.1046 0.895431 26 2 26H30C31.1046 26 32 25.1046 32 24V18.6667C32 16.9357 31.4386 15.2514 30.4 13.8667L29 12H30C31.1046 12 32 11.1046 32 10C32 9.44772 31.5523 9 31 9H28.5L27.2785 1.6712C27.1178 0.706825 26.2834 0 25.3057 0H6.69425ZM7.90499 2C7.39124 2 6.96107 2.3893 6.90995 2.9005L6 12H26L25.09 2.9005C25.0389 2.38929 24.6088 2 24.095 2H7.90499ZM2 18C2 17.4477 2.44772 17 3 17H7C7.55228 17 8 17.4477 8 18V20C8 20.5523 7.55228 21 7 21H3C2.44772 21 2 20.5523 2 20V18ZM11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19H21C21.5523 19 22 18.5523 22 18C22 17.4477 21.5523 17 21 17H11ZM10 22C10 21.4477 10.4477 21 11 21H21C21.5523 21 22 21.4477 22 22C22 22.5523 21.5523 23 21 23H11C10.4477 23 10 22.5523 10 22ZM25 17C24.4477 17 24 17.4477 24 18V20C24 20.5523 24.4477 21 25 21H29C29.5523 21 30 20.5523 30 20V18C30 17.4477 29.5523 17 29 17H25Z",
    fill: "#FF552E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 31V28H8V31C8 31.5523 7.55228 32 7 32H3C2.44772 32 2 31.5523 2 31Z",
    fill: "#FF552E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31V28H30V31C30 31.5523 29.5523 32 29 32H25C24.4477 32 24 31.5523 24 31Z",
    fill: "#FF552E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransportation);
export default __webpack_public_path__ + "static/media/icon-transportation.331e5547372fd34ddf661923b559f55d.svg";
export { ForwardRef as ReactComponent };